import { Component, inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { UI_DATEPIPE_MMM_D_FORMAT } from '../../parser.service';
import { T7eService } from '../../t7e/t7e.service';
import { filter } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

export interface PromptOtherAllowancePopupData {
  code_other?: string | null
  // csak megjelenítéshez
  usname?: string | null
  role?: string | null
  startdate?: string | Date | null
  otherfee?: number | null
  currency?: string | null
  comment?: string | null
}

@Component({
  selector: 'app-prompt-other-allowance-popup',
  templateUrl: './prompt-other-allowance-popup.component.html',
  styleUrls: ['./prompt-other-allowance-popup.component.scss']
})
export class PromptOtherAllowancePopupComponent implements OnInit {
  private readonly t7e = inject(T7eService)
  private readonly dialogRef = inject<MatDialogRef<PromptOtherAllowancePopupComponent, string>>(MatDialogRef)
  readonly data = inject<PromptOtherAllowancePopupData | null>(MAT_DIALOG_DATA, { optional: true })

  readonly DATE_FORMAT = UI_DATEPIPE_MMM_D_FORMAT

  code_other = new FormControl<string>(this.data?.code_other ?? '', { nonNullable: true, validators: Validators.required })

  /** OK-ra resolve-ol a megadott kóddal, Cancel-re (vagy bármilyen más bezárásra) reject-el */
  readonly result: Promise<string>
  private resolveFn!: (code: string) => void
  private rejectFn!: (reason?: any) => void

  /**
   * Megnyitja a popupot, és visszaadja a felhasználó válaszára váró promise-t
   * @example const code = await PromptOtherAllowancePopupComponent.open(this.dialog, { code_other: 'ABC' })
   */
  static open(dialog: MatDialog, data?: PromptOtherAllowancePopupData): Promise<string> {
    const dialogRef = dialog.open(PromptOtherAllowancePopupComponent, {
      width: '400px',
      data,
      // Bezáródik-e dialog a háttérre kattintásra
      //disableClose: true,
    })
    return dialogRef.componentInstance.result
  }

  constructor() {
    this.result = new Promise<string>((resolve, reject) => {
      this.resolveFn = resolve
      this.rejectFn = reject
    })
    // ha nem OK-val zárták be, akkor se maradjon függőben a promise (ha már resolve-olt, nincs hatása)
    this.dialogRef.afterClosed().subscribe(() => this.rejectFn({statusText: this.t7eCancelled}))
    // disableClose miatt az ESC-et kézzel kezeljük (a háttérre kattintás továbbra sem zárja be)
    this.dialogRef.keydownEvents()
      .pipe(filter(e => e.key === 'Escape'))
      .subscribe(() => this.onCancelled())
  }

  ngOnInit(): void {
  }

  onConfirmed(): void {
    if (this.code_other.invalid) return
    const code = this.code_other.value.trim()
    this.resolveFn(code)
    this.dialogRef.close(code)
  }

  onCancelled(): void {
    this.rejectFn({statusText: this.t7eCancelled})
    this.dialogRef.close()
  }

  readonly componentName = 'app-prompt-other-allowance-popup'
  t7eCancelled = this.t7e.getTranslation(this.componentName, 'reject-reason', 'cancelled', null, null, 'A kód megadása megszakítva')

}
